module.exports = __webpack_public_path__ + "static/media/portfolio-example-03.2b2d25a8.jpg";